@if (showBreadcrumb){
<shared-breadcrumb [routes]="routes"></shared-breadcrumb>
}

<div id="entities" class="page-layout carded fullwidth" wtfPerfectScrollbar>
    <!-- TOP BACKGROUND -->
    <div class="top-bg"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- HEADERs -->
        <div class="header white-fg button-align">
            <!-- APP TITLE -->
            <!-- <div fxLayout="column" class="font-color">
                <div class="logo my-12 m-sm-0" fxLayout="row" fxLayoutAlign="center center">

                    <mat-icon *ngIf="icon" class="material-icons-outlined logo-icon mr-32 font-color"
                        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                        {{icon}}
                    </mat-icon>

                    <span class="logo-text h1 mb-0" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                        {{title}}</span>
                </div>
                <div *ngIf="subtitle" class="subtitle secondary-text">
                    <span>{{subtitle}}</span>
                </div>
            </div> -->
            <!-- / APP TITLE -->

            <!-- Buttons -->
            <div class="toolbar-separator">
            </div>
            <div class="actions ng-tns-c65-453 ng-trigger ng-trigger-animate" ng-reflect-layout="row"
                ng-reflect-align="end center">
                <div class="btn-group">
                    <ng-content select="button" class="add-entity-button  my-12 mt-sm-0"></ng-content>
                </div>
            </div>
            <!-- /Buttons -->
        </div>
        <!-- / HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card">
            <ng-content></ng-content>
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>